export const CourseProgressType = Object.freeze({
  notStarted: 0,
  started: 1,
  completed: 2,
});
